import { useMemo } from 'react';

import { useStore } from '../stores/useEnrollmentMatrixFieldsState.store';

export default () => {
  const enrollmentMatrixStore = useStore((state) => state.sourceState);

  const state = useMemo(() => ({
    ...enrollmentMatrixStore,
  }), [enrollmentMatrixStore]);
  return state;
};
